import {getToken} from '../lib/auth'
import {isEmpty} from '../lib/tools'

class RestClient {
  constructor(host) {
    this.host = host

    this.read = this.read.bind(this)
    this.post = this.post.bind(this)
    this.put = this.put.bind(this)
    this.patch = this.patch.bind(this)
    this.delete = this.delete.bind(this)
  }

  #url(endpoint) { return `${this.host}/${endpoint}` }

  #options(method, payload) {
    const token = getToken('authToken')
    let options = {method, headers: {'Content-Type': 'application/json'}}

    if (!isEmpty(payload))
      options = {...options, body: JSON.stringify(payload)}

    if (token)
      options = {...options, headers: {...options.headers, authorization: token}}

    return options
  }

  /**
   * The API answers in the same envelope whether or not it succeeded, so the status code is the only
   * thing separating a refusal worth retrying from one that never will be — a recovery key that is
   * seconds away reads exactly like one that is never coming.
   *
   * It is merged into the body rather than wrapped around it so every existing caller goes on
   * reading `success`, `data` and `message` untouched. The name avoids `status`, which already means
   * a record's own state elsewhere in the payloads.
   */
  #send({endpoint, method = 'GET', payload = {}}) {
    return fetch(this.#url(endpoint), this.#options(method, payload)).then(
      response => response.json().then(body => ({...body, statusCode: response.status}))
    )
  }

  read(endpoint) {
    return this.#send({endpoint})
  }

  put(endpoint, payload) {
    return this.#send({endpoint, method: 'PUT', payload})
  }

  patch(endpoint, payload) {
    return this.#send({endpoint, method: 'PATCH', payload})
  }

  post(endpoint, payload) {
    return this.#send({endpoint, method: 'POST', payload})
  }

  delete(endpoint) {
    return this.#send({endpoint, method: 'DELETE'})
  }
}

export default RestClient
